import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { RemoteContactCard } from 'features/crm';
import { getInitials } from 'shared/utils';
import { FullStoryExclude, FullStoryMask } from '../../../../../../../shared/fullstory_privacy';
import CancelledIcon from '../cancel.svg';
import { AvatarContainer, AvatarIcon, AvatarDropdownContainer, Heading, Name, NameString } from '../styles';
const displayNameCss = "d121a1ud";
const DisplayName = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayNameCss, props.className)} />;
});
export const AvatarDropdown = ({
  displayName,
  cancelled,
  isHost,
  isContact,
  canShowMoreInfo,
  handleClick,
  nameButtonRef,
  contact
}) => {
  const isCRMContactCardEnabled = useNewCode('crm_contactcard_feature')?.enabled;
  return <>
      <AvatarContainer>
        <FullStoryExclude>
          <Avatar letter={getInitials(displayName)} alt={displayName} aria-label={displayName} size="small" tooltip={displayName} />
          {cancelled && <AvatarIcon src={CancelledIcon} />}
        </FullStoryExclude>
      </AvatarContainer>
      <Heading isContact={isContact}>
        {!canShowMoreInfo && <NameString strike={cancelled}><FullStoryMask>{displayName}</FullStoryMask></NameString>}
        {canShowMoreInfo && isCRMContactCardEnabled && contact && <AvatarDropdownContainer>
            <RemoteContactCard contact={contact} position="below">
              <Name strike={cancelled} onClick={handleClick} ref={nameButtonRef}>
                <DisplayName><FullStoryMask>{displayName}</FullStoryMask></DisplayName>
              </Name>
            </RemoteContactCard>
          </AvatarDropdownContainer>}
        {canShowMoreInfo && (!isCRMContactCardEnabled || !contact) && <Name strike={cancelled} onClick={handleClick} ref={nameButtonRef}>
            <DisplayName><FullStoryMask>{displayName}</FullStoryMask></DisplayName>
          </Name>}
        {isHost && <BodyText size="x-small" color={colorTextSecondary}>{I18n.t('publisher.meetings.invitees.meeting_owner')}</BodyText>}
      </Heading>
    </>;
};

require("./avatar_dropdown.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar_dropdown.js");